import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Notification,
  type NotificationProps,
} from '@packages/shared/src/ui/Notification/Notification';
import { Link } from '@packages/modules/src/Link/Link';
import type { DownPaymentFragmentFragment } from '@packages/gql/generated/shopping/graphql';

type DownPaymentInlineNotificationProps = DownPaymentFragmentFragment & {
  // this overwrite ensures that downPaymentRequired is not undefined
  downPaymentRequired: NonNullable<DownPaymentFragmentFragment['downPaymentRequired']>;
} & NotificationProps;

export const DownPaymentInlineNotification: FC<DownPaymentInlineNotificationProps> = ({
  downPaymentRequired,
  paylink,
  ...rest
}) => (
  <Notification severity="info" variant="outline" {...rest}>
    <FormattedMessage
      id="CustomerOrders.DownPaymentRequired"
      defaultMessage="Damit wir Deine Bestellung weiter verarbeiten können, benötigen wir von Dir eine Anzahlung in Höhe von {value, number} {currency}. Schnell, sicher, einfach."
      values={{
        value: downPaymentRequired.value / 100,
        currency: downPaymentRequired.currencyCode,
      }}
    />
    {paylink && (
      <>
        <br />
        <Link href={paylink} className="underline">
          <FormattedMessage id="CustomerOrders.DownPaymentLink" defaultMessage="Jetzt anzahlen" />
        </Link>
      </>
    )}
  </Notification>
);
